export class Slide {
    titre: string;
    description: string;
    slide_image: any;
   

    private errorMessage: string;

    constructor() {

        this.errorMessage = "";
    }

    canSend(): boolean {
        // Vérification de l'adresse email
        if (this.titre === undefined || this.titre === null || this.titre.trim() === "") {
            this.errorMessage = "Veuillez renseigner le titre.";
            return false;
        }
        
          if (this.description === undefined || this.description === null || this.description.trim() === "") {
            this.errorMessage = "Veuillez renseigner la description.";
            return false;
        }
         if (this.slide_image === undefined || this.description === null ) {
            this.errorMessage = "Veuillez renseigner  une image.";
            return false;
        }
    
        // Toutes les vérifications sont passées
        return true;
    }
    
    

    getErrorMessage(): string {
        return this.errorMessage;
    }
}
